import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { alpha, useTheme } from '@mui/material/styles'
import type { StudyStatus } from './dashboardTypes'

/** Small dot + label pill describing a study's lifecycle state. */
export default function StatusPill({ kind }: { kind: StudyStatus }) {
  const theme = useTheme()
  const { t } = useTranslation('dashboard')
  const c = theme.affexy.colors

  const map: Record<StudyStatus, { bg: string; fg: string; dot: string }> = {
    active: { bg: alpha(c.success, 0.16), fg: '#3D8077', dot: c.success },
    paused: { bg: alpha(c.warning, 0.16), fg: '#B0701F', dot: c.warning },
    done: { bg: alpha(c.ink, 0.08), fg: c.ink72, dot: c.ink56 },
    draft: { bg: alpha(c.gray300, 0.28), fg: c.ink56, dot: c.gray300 },
    review: { bg: alpha(c.coral, 0.1), fg: c.coralHover, dot: c.coral },
    danger: { bg: alpha(c.danger, 0.16), fg: '#A12F2A', dot: c.danger },
  }
  const s = map[kind]

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        pl: 1,
        pr: 1.25,
        py: 0.375,
        borderRadius: theme.affexy.radii.pill / 8,
        fontSize: 11.5,
        fontWeight: 500,
        bgcolor: s.bg,
        color: s.fg,
        whiteSpace: 'nowrap',
      }}
    >
      <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: s.dot }} />
      {t(`status.${kind}`)}
    </Box>
  )
}
